import { render, staticRenderFns } from "./VisitRequests.vue?vue&type=template&id=22f80642&"
import script from "./VisitRequests.vue?vue&type=script&lang=js&"
export * from "./VisitRequests.vue?vue&type=script&lang=js&"
import style0 from "./VisitRequests.vue?vue&type=style&index=0&id=22f80642&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports